import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Modal, Button } from 'Components';
import './NotificationModal.css';

const
  NotificationModal = props => (
  <Modal show={props.show}>
    <div className="Notification-modal">
      <div className="Notification-modal__container">
        {props.Message && <h3>{props.Message}</h3>}
        <div className="Notification-modal__buttons">
            <Button
              onClick={props.onCloseClick} 
              className="button button--primary"
            >
              {i18n.t('common:Close')}
            </Button> 
                     
        </div>
      </div>
    </div>
  </Modal>
);

NotificationModal.propTypes = {
  Message: PropTypes.string,
  show: PropTypes.bool,
  onCloseClick: PropTypes.func,
};

export default NotificationModal;



// WEBPACK FOOTER //
// ./src/components/NotificationModal/NotificationModal.jsx